.constraints {
  width: 100%;
  box-sizing: border-box;
  padding-right: var(--constraints\:padding-x);
  padding-left: var(--constraints\:padding-x);
  margin: 0 auto;
}

.escape {
  > div {
    // Expand to root component element if that is expanded
    height: 100%;
    margin: 0 auto;
  }
  &.padding {
    margin-right: calc(-1 * var(--constraints\:padding-x));
    margin-left: calc(-1 * var(--constraints\:padding-x));
  }
  &.width {
    // TODO: Unimplemented
    background: red;
  }
}

.only {
  &.padding {
    padding: 0 var(--constraints\:padding-x);
  }
  &.width {
    max-width: 800px;
    margin: 0 auto;
  }
}
